import axios from "../axios";
const END_POINT = "/service-properties";

const getServiceProperties = () =>
  axios.get(`${END_POINT}`);
const searchServiceProperties = (payload) =>
  axios.post(`${END_POINT}/search`, payload);

export {
  getServiceProperties,searchServiceProperties
};
